"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _InterestAccountsSettingContainer = _interopRequireDefault(require("./InterestAccountsSettingContainer"));
require("./TradeSettings.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('trade-settings');
var InterestSettings = function InterestSettings(_ref) {
  var getInterestAccountStatus = _ref.getInterestAccountStatus,
    selectedAccountId = _ref.selectedAccountId;
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    getInterestAccountStatus();
    return function () {};
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedAccountId]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('header-text')
  }, t('Adjust Yield Settings')), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('description')
  }, t('Lorem ipsum dolor sit amet, consectetur adipiscing  elit.'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('settings')
  }, /*#__PURE__*/_react["default"].createElement(_InterestAccountsSettingContainer["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  })));
};
var _default = exports["default"] = InterestSettings;